import * as React from 'react';
import { observer } from 'mobx-react';
import { RecordedCardPaymentMethod } from './payment-entry-model';
import { FormControlLabelled, FormControlType } from '../../../components/form-controls/form-control-labelled';
import { ModelMetadata } from '../../virtual-terminal-generated';

@observer
export class PaymentMethodRecordedCard extends React.Component<{ card: RecordedCardPaymentMethod }, {}> {
	render() {
		const { paymentReference } = this.props.card;

		return (
			<div className="vt-payment-method">
				<FormControlLabelled label="Payment reference (optional)"
					formControlProps={{
						formControlType: FormControlType.Text,
						name: ModelMetadata.RecordedCreditCardModel.Reference.propertyName,
						placeholder: 'Enter a payment reference',
						type: 'text',
						value: paymentReference,
						onChangeHandler: this.handlePaymentReferenceChange,
						maxLength: this.referenceValidationRules.length.parameters.max,
						validationRules: this.referenceValidationRules,
						acceptanceTestTargetId: 'payment reference - card - recorded'
					}} />
			</div>
		);
	}

	private handlePaymentReferenceChange = (event: React.FormEvent<HTMLInputElement>) => {
		this.props.card.updatePaymentReference(event.currentTarget.value);
	}

	private get referenceValidationRules() {
		return ModelMetadata.RecordedCreditCardModel.Reference.validationRules;
	}
}
